import { Box } from '@mui/joy';
import { Chapter } from '../../types';
import { useChapterColors } from '../../hooks';

export interface DotProps extends Chapter {
	variant: 1 | 2 | 3;
	diameter?: string;
	type?: 'solid' | 'clear';
}

export const Dot = ({
	chapter = 'donors',
	variant = 1,
	diameter = '21px',
	type
}: DotProps) => {
	const { getColor } = useChapterColors();

	return (
		<Box
			sx={{
				height: diameter,
				width: diameter,
				borderRadius: '50%',
				backgroundColor:
					type === 'clear'
						? 'transparent'
						: getColor(chapter)[`solidBg${variant === 1 ? '' : variant}`],
				borderWidth: type === 'clear' ? 1 : 0,
				borderStyle: type === 'clear' && variant === 1 ? 'solid' : 'none',
				borderColor: getColor(chapter)[`solidBg`]
			}}
		/>
	);
};
